<template>
    <button @click="surpriseMe" id="surprise-me-button">
        <div class="d-flex align-items-center gap-10">
            <i class="fa fa-magic"></i>
            <span>{{ 'Surprise me' | trans }}</span>
        </div>
    </button>
</template>
<script>
import store from '../../../mixins/store.mixin';
import currentJob from '../../../mixins/current_job.mixin';
import PromptEditorManager from '../../../manager/PromptEditorManager';
import Analytics from "../../../util/Analytics";

export default {
    name: 'SurpriseMeButton',
    mixins: [store, currentJob],
    created() {},
    methods: {
        surpriseMe() {
          Analytics.send('creator_studio_action', `surprise_me`, this.currentJob);

          PromptEditorManager.surpriseMe({ id: this.id });
        },
    },
};
</script>
<style lang="scss" scoped>
#surprise-me-button {
    width: 85%;
    min-height: 38px;
    background-color: #383838;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #595959;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    color: #e8eaed;
    &:hover {
        background: #323232;
        i {
            color: #ffaa00;
        }
    }
}
</style>
